function init() {
  const elToggles = [...document.querySelectorAll('[data-review-toggle]')];
  const elCloses = [...document.querySelectorAll('[data-review-close]')];
  const state = {
    target: null,
  };

  function close(elTarget) {
    elTarget.classList.remove('active');
    state.target = null;
  }

  function open(elTarget) {
    closeAll();
    elTarget.classList.add('active');
    state.target = elTarget;
  }

  function toggle(elTarget) {
    state.target === elTarget ? close(elTarget) : open(elTarget);
  }

  function closeAll() {
    [...document.querySelectorAll('[data-review-id]')].forEach(el => close(el));
  }

  elToggles.forEach((el) => {
    el.addEventListener('click', () => {
      toggle(el.closest('.expert'));
      toggle(document.querySelector(`[data-review-id="${el.dataset.reviewToggle}"]`));
    });
  });

  elCloses.forEach((el) => {
    el.addEventListener('click', () => {
      let elTarget = el.closest('[data-review-id]');
      close(elTarget);
      close(document.querySelector(`[data-review-toggle="${elTarget.dataset.reviewId}"]`).closest('.expert'));
    });
  });

}

export default {init};
